import { Injectable } from '@angular/core';
import { Questionnaire } from '../../../../../backend/server/data-models/questionnaire/questionnaire.model';
import { QuestionnaireType } from '../../../../../backend/server/data-models/questionnaire-template/questionnaire-template.model';
import { MongoObservable } from 'meteor-rxjs';
import { AbstractService } from '../../shared/AbstractService';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService extends AbstractService<Questionnaire> {

  constructor() {
    super("questionnaire");
  }

  delete(id: string, seq: number): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return Meteor.call("questionnaire.delete", id, seq, (err, res) => {
        // console.warn("questionnaire.delete - id: " + id + "; seq: " + seq);
        if (!err) {
          // console.warn(res);
          resolve(res);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  get(id: string): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      Meteor.call("questionnaire.get", id, (err, res) => {
        // console.warn("questionnaire.get");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  list(name: string, type: QuestionnaireType, created: boolean, started: boolean, closed: boolean, revoked: boolean): Promise<Questionnaire[]> {
    return new Promise<Questionnaire[]>((resolve, reject) => {
      Meteor.call("questionnaire.list", name, type, created, started, closed, revoked, (err, res) => {
        // console.warn("questionnaire.list");
        if (!err) {
          // console.warn(res);
          if (Array.isArray(res)) {
            resolve(res.map(q => new Questionnaire(q)));
          } else {
            reject("Invalid result type!")
          }
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  create(data: Questionnaire, templateId: string): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      return Meteor.call("questionnaire.create", data, templateId, (err, res) => {
        // console.warn("questionnaire.create");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          // console.warn(err);
          reject(err);
        }
      });
    });
  }

  update(id: string, seq: number, tempalteId: string, data: Questionnaire): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      return Meteor.call("questionnaire.update", id, seq, tempalteId, data, (err, res) => {
        // console.warn("questionnaire.update");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  start(id: string, seq: number): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      return Meteor.call("questionnaire.start", id, seq, (err, res) => {
        // console.warn("questionnaire.start");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  close(id: string, seq: number): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      return Meteor.call("questionnaire.close", id, seq, (err, res) => {
        // console.warn("questionnaire.close");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

  revoke(id: string, seq: number): Promise<Questionnaire> {
    return new Promise<Questionnaire>((resolve, reject) => {
      return Meteor.call("questionnaire.revoke", id, seq, (err, res) => {
        // console.warn("questionnaire.revoke");
        if (!err) {
          // console.warn(res);
          resolve(res ? new Questionnaire(res) : null);
        } else {
          console.warn(err);
          reject(err);
        }
      });
    });
  }

}
